<footer class="footer">
  <div class="footer__container">
    <div class="footer__content">
      <img src="assets/deipe_white.png" alt="Deipe" class="footer__logo" />
    </div>
  </div>
</footer>
